import type { InstructionFeedbackActivityProduct } from "@/models/instruction-feedback-activity-product"
import { defineStore, storeToRefs } from "pinia"
import { useInstructionFeedbacksActivitiesStore } from "@/store/instruction-feedbacks-activities.store"
import { useRelatedObjectsManager } from "@/composables/socket/related-objects-manager"
import { InstructionFeedbackActivity } from "@/models/instruction-feedback-activity.model"

export const useInstructionFeedbacksActivitiesProductsStore = defineStore(
  "instructionFeedbacksActivitiesProductsStore",
  () => {
    const instructionFeedbacksActivitiesStore = useInstructionFeedbacksActivitiesStore()
    const { appInstructionFeedbackActivities, planningInstructionFeedbackActivities } = storeToRefs(
      instructionFeedbacksActivitiesStore
    )

    const {
      pushToRelatedObjects: pushToRelatedAppInstructions,
      removeFromRelatedObjects: removeFromRelatedAppInstructions
    } = useRelatedObjectsManager(
      appInstructionFeedbackActivities,
      (instructionFeedbackActivityProduct: InstructionFeedbackActivityProduct) =>
        instructionFeedbackActivityProduct.instructionFeedbackActivity,
      (instructionFeedbackActivity: InstructionFeedbackActivity) => instructionFeedbackActivity?.id,
      (instructionFeedbackActivity: InstructionFeedbackActivity) =>
        instructionFeedbackActivity.instructionFeedbackActivityProducts
    )

    const {
      pushToRelatedObjects: pushToRelatedPlanningInstructions,
      removeFromRelatedObjects: removeFromRelatedPlanningInstructions
    } = useRelatedObjectsManager(
      planningInstructionFeedbackActivities,
      (instructionFeedbackActivityProduct: InstructionFeedbackActivityProduct) =>
        instructionFeedbackActivityProduct.instructionFeedbackActivity,
      (instructionFeedbackActivity: InstructionFeedbackActivity) => instructionFeedbackActivity?.id,
      (instructionFeedbackActivity: InstructionFeedbackActivity) =>
        instructionFeedbackActivity.instructionFeedbackActivityProducts
    )

    return {
      pushToRelatedAppInstructions,
      removeFromRelatedAppInstructions,
      pushToRelatedPlanningInstructions,
      removeFromRelatedPlanningInstructions
    }
  }
)
